/** Ankr certificate tokens (ankrETH / ankrBNB / ankrAVAX / ankrMATIC)
 *  expose `ratio()` — the 1e18-scaled *shares-per-underlying* rate
 *  (inverse of the usual convention). It decreases as staking rewards
 *  accrue, so underlying-per-share = 1e18 * 1e18 / ratio(). */
export const AnkrRatioAbi = [
  {
    name: 'ratio',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
